import { Button, Stack, Typography, useTheme } from "@mui/material";
import ScoutIcon from "components/ScoutIcon";
import { useMemo } from "react";

import { ScoutInput } from "./ScoutInput";
import { SCOUT_SUGGESTIONS, SCOUT_SUGGESTIONS_DISPLAY_COUNT } from "./suggestions";

const SUGGESTIONS_PER_ROW = 2;

export function NewChat({
  onSubmit,
  onAbort,
  isSending,
}: {
  onSubmit: (text: string) => Promise<void>;
  onAbort: () => void;
  isSending: boolean;
}) {
  const theme = useTheme();

  const suggestionRows = useMemo(() => {
    const picked = SCOUT_SUGGESTIONS.slice(0, SCOUT_SUGGESTIONS_DISPLAY_COUNT);
    const rows: (typeof picked)[] = [];
    for (let i = 0; i < picked.length; i += SUGGESTIONS_PER_ROW) {
      rows.push(picked.slice(i, i + SUGGESTIONS_PER_ROW));
    }
    return rows;
  }, []);

  return (
    <Stack
      sx={{
        flex: 1,
        width: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
        paddingTop: { xs: 8, sm: 9 },
        paddingBottom: { xs: 10, sm: 12 },
        transform: "translateY(calc(-2vh - 100px))",
        gap: 5,
      }}
    >
      <ScoutIcon sx={{ color: theme.palette.encampBlue.main, width: 80, height: 80 }} />
      <Typography variant="h6" textAlign="center">
        Hey there! I'm Scout, your Encamp guide. How can I help you today?
      </Typography>

      {suggestionRows.length > 0 && (
        <Stack spacing={1}>
          <Typography variant="caption" color="text.secondary">
            Suggestions
          </Typography>
          <Stack spacing={3}>
            {suggestionRows.map((row) => (
              <Stack
                key={row.map((s) => s.label).join("|")}
                direction="row"
                spacing={3}
                justifyContent="center"
              >
                {row.map((suggestion) => (
                  <Button
                    key={suggestion.label}
                    variant="contained"
                    color="encampBlue"
                    size="small"
                    disabled={isSending}
                    onClick={() => onSubmit(suggestion.prompt)}
                    sx={{ textTransform: "none", px: "22px", py: "8px", flexShrink: 0 }}
                  >
                    {suggestion.label}
                  </Button>
                ))}
              </Stack>
            ))}
          </Stack>
        </Stack>
      )}

      <ScoutInput
        onSubmit={onSubmit}
        onAbort={onAbort}
        isSending={isSending}
        placeholder="Check regulations, help me understand compliance requirements..."
      />
    </Stack>
  );
}
